import { render, staticRenderFns } from "./qualificationSecond.vue?vue&type=template&id=ecd5af9a&scoped=true&"
import script from "./qualificationSecond.vue?vue&type=script&lang=js&"
export * from "./qualificationSecond.vue?vue&type=script&lang=js&"
import style0 from "./qualificationSecond.vue?vue&type=style&index=0&id=ecd5af9a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd5af9a",
  null
  
)

export default component.exports